import { ConvertTimestamps, FirestoreTimestamp } from '@griply/types';
import { isNumber } from '@griply/utils';

const isRecord = (val: unknown): val is Record<string, unknown> =>
  val !== null && typeof val === 'object' && !Array.isArray(val);

export const firebaseTimestampToDate = (
  timestamp?: FirestoreTimestamp | Date | null,
): Date | null => {
  if (!timestamp) {
    return null;
  }
  if (timestamp instanceof Date) {
    return timestamp;
  }

  const ms =
    (timestamp.seconds as number) * 1000 +
    Math.floor(timestamp.nanoseconds / 1_000_000);
  const date = new Date(ms);
  return isNaN(date.getTime()) ? null : date;
};

const convert = (obj: unknown): unknown => {
  if (obj instanceof Date) {
    return obj;
  }
  if (isRecord(obj) && typeof obj.toDate === 'function') {
    const date = (obj as { toDate: () => Date }).toDate();
    return isNaN(date.getTime()) ? null : date;
  }
  if (isRecord(obj) && isNumber(obj.seconds) && isNumber(obj.nanoseconds)) {
    const ms =
      (obj.seconds as number) * 1000 +
      Math.floor((obj.nanoseconds as number) / 1_000_000);
    const date = new Date(ms);
    return isNaN(date.getTime()) ? null : date;
  }
  if (Array.isArray(obj)) {
    return obj.map((item) => convert(item));
  }
  if (isRecord(obj)) {
    const transformedObj: Record<string, unknown> = {};
    for (const key in obj) {
      if (Object.hasOwn(obj, key)) {
        transformedObj[key] = convert(obj[key]);
      }
    }
    return transformedObj;
  }

  return obj;
};

// Cast: TS can't track runtime narrowing (instanceof/Array.isArray/isRecord) through ConvertTimestamps<T>.
export const firebaseObjectTimestampToDate = <T>(
  obj: T,
): ConvertTimestamps<T> => convert(obj) as ConvertTimestamps<T>;
